module.exports = __webpack_public_path__ + "static/media/egg.3fa1a683.svg";